"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("./Button");
var _constants = require("./constants");
var _DropdownMenu = _interopRequireDefault(require("./styles/DropdownMenu"));
var _useOutsideClick = require("./hooks/useOutsideClick");
var _useDebounce = require("./hooks/useDebounce");
var _excluded = ["id", "className", "icon", "align", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function DropdownMenu(_ref) {
  var id = _ref.id,
    className = _ref.className,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? _constants.Icons.settings : _ref$icon,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? _constants.Strings.center : _ref$align,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isDropdownOpen = _useState2[0],
    setOpen = _useState2[1];
  var menuParent = (0, _react.useRef)();
  var togglerId = id ? "".concat(id, "-toggler") : null;
  var menuId = id ? "".concat(id, "-menu") : null;
  var isFnChildren = typeof children === 'function';
  var closeMenu = function closeMenu() {
    return setOpen(false);
  };
  var debounceIsDropdownOpen = (0, _useDebounce.useDebounce)(isDropdownOpen);
  var element = debounceIsDropdownOpen ? menuParent.current : null;
  (0, _useOutsideClick.useOutsideClick)(element, closeMenu);
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: (0, _classnames["default"])('dropdown-menu', _DropdownMenu["default"].container, className)
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, (0, _extends2["default"])({
    id: togglerId,
    className: (0, _classnames["default"])('dropdown-menu__toggler', _DropdownMenu["default"].toggler),
    "aria-label": "Open dropdown menu",
    icon: icon
  }, props, {
    onClick: function onClick() {
      return setOpen(true);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    ref: menuParent
  }, isDropdownOpen && /*#__PURE__*/_react["default"].createElement("ul", {
    id: menuId,
    className: (0, _classnames["default"])('dropdown-menu__menu', _DropdownMenu["default"].menu, _DropdownMenu["default"]["menu_".concat(align)]),
    role: "menu"
  }, /*#__PURE__*/_react["default"].createElement("li", {
    className: (0, _classnames["default"])('dropdown-menu__arrow', _DropdownMenu["default"].arrow, _DropdownMenu["default"]["arrow_".concat(align)])
  }), isFnChildren ? children(closeMenu) : children)));
}
DropdownMenu.displayName = 'DropdownMenu';
var _default = exports["default"] = DropdownMenu;